package com.klantenstop.web.data.models.dto.requests.user

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateUser(
    @SerialName("first_name")
    val firstName: String? = null,
    @SerialName("last_name")
    val lastName: String? = null,
    val email: String? = null
)  {

    val isValid get() = !firstName.isNullOrBlank() || !firstName.isNullOrBlank() || !email.isNullOrBlank()
}

